import {
    GLOSSARY_GRID_RULE,
    LAUNCHER_GRID_ORDER,
    LAUNCHER_KEY_MATCHERS,
    LAUNCHER_LABEL_IDS,
    PATHS
} from './launcher-config';

export { LAUNCHER_GRID_ORDER, LAUNCHER_LABEL_IDS, PATHS };

export const isPlayersLink = to => LAUNCHER_KEY_MATCHERS.find(matcher => matcher.key === 'players')?.test(to) ?? false;

export const isTeamsLink = to => LAUNCHER_KEY_MATCHERS.find(matcher => matcher.key === 'teams')?.test(to) ?? false;

export const isEventsLink = to => LAUNCHER_KEY_MATCHERS.find(matcher => matcher.key === 'events')?.test(to) ?? false;

export const isPrimaryNavLink = to => isPlayersLink(to) || isTeamsLink(to) || isEventsLink(to);

export const getLauncherKey = to => {
    if (!to) {
        return null;
    }
    const match = LAUNCHER_KEY_MATCHERS.find(matcher => matcher.test(to));

    return match?.key ?? null;
};

export const isLinkVisible = (link, roleProps) => !link.isVisible || link.isVisible(roleProps);

export const ensureGlossaryInGrid = (byKey, visibleLinks) => {
    if (byKey[GLOSSARY_GRID_RULE.key]) {
        return byKey;
    }

    const supportLink =
        byKey[GLOSSARY_GRID_RULE.supportKey] ||
        visibleLinks.find(link => GLOSSARY_GRID_RULE.supportPathPattern.test(link.to));
    const glossaryFromSubmenu = supportLink?.submenu?.find(link =>
        GLOSSARY_GRID_RULE.glossaryPathPattern.test(link.to)
    );

    if (glossaryFromSubmenu) {
        return { ...byKey, [GLOSSARY_GRID_RULE.key]: glossaryFromSubmenu };
    }

    if (supportLink?.to) {
        return {
            ...byKey,
            [GLOSSARY_GRID_RULE.key]: {
                ...supportLink,
                to: GLOSSARY_GRID_RULE.buildPath(supportLink.to),
                submenu: undefined
            }
        };
    }

    return byKey;
};

export const buildLauncherGridItems = (visibleLinks, isLimitedAccount) => {
    if (isLimitedAccount) {
        return visibleLinks.map(link => ({
            key: getLauncherKey(link.to) || link.to,
            link
        }));
    }

    const byKey = {};
    const consider = link => {
        const key = getLauncherKey(link.to);
        if (key && !byKey[key]) {
            byKey[key] = link;
        }
        // eslint-disable-next-line no-restricted-syntax -- TODO: legacy forEach/switch (baseline)
        (link.submenu || []).forEach(consider);
    };
    // eslint-disable-next-line no-restricted-syntax -- TODO: legacy forEach/switch (baseline)
    visibleLinks.forEach(consider);

    const withGlossary = ensureGlossaryInGrid(byKey, visibleLinks);

    return LAUNCHER_GRID_ORDER.map(key => (withGlossary[key] ? { key, link: withGlossary[key] } : null)).filter(
        Boolean
    );
};

const ADMIN_ROOTS = ['/scout-admin', '/clients-admin', '/schedule-admin'];

export const isAdminAreaPath = pathname =>
    !!pathname && ADMIN_ROOTS.some(root => pathname === root || pathname.startsWith(`${root}/`));

export const isCollectorGamePagePath = pathname =>
    !!pathname && (/^\/collector\/game\/[^/]+/.test(pathname) || /^\/lite-collector\/game\/[^/]+/.test(pathname));

export const isCenteredHeaderNavPath = pathname => isAdminAreaPath(pathname) || isCollectorGamePagePath(pathname);
